import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import './Thanks.css';

const Thanks: React.FC = () => {
  const { t } = useLanguage();
  return (
    <div className="thanks-page">
      <div className="container">
        <img 
          src="/e6bc9b84-c312-461e-ac75-0ddc311a20bc_200x200.png" 
          alt="Export Used Car Parts" 
          className="logo"
        />
        <h1>{t('thanks.title')}</h1>
        <p>{t('thanks.message.part1')}</p>
        <p>{t('thanks.message.part2')}</p>
        <Link to="/" className="btn">{t('thanks.backButton')}</Link>
      </div>
    </div>
  );
};

export default Thanks;
